/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$('body').on('click','.upsell_add_to_cart',function(e){
  e.preventDefault();
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  $('.PageOverlay').addClass('is-visible');
  var id = $(this).data('id');
  var i = 1;   
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: { id: id, quantity: i },
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);            
    },
    success: function() {
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: id,
          quantity: 1
        }
      }));
    }         
  });
  document.dispatchEvent(new CustomEvent('theme:loading:end'));
});
